export default __webpack_public_path__ + "static/media/clarity_bell-solid.bf574043.svg";